import CourseBlockInterface from "../../../Interfaces/CourseBlockInterface";
import ProgressScale from "../../UI/ProgressScale";

const ModuleListHeadBlock = ({
  title,
  duration,
  hours,
  document_name,
  layout,
  background_color,
  scale,
  max,
}: CourseBlockInterface) => {
  return (
    <div className="headCourseBlock">
      <div className="courseBlockText courseHeadText">
        <h1>{title}</h1>

        <div className="courseInfo">
          <div>
            <p>Длительность обучения: </p>
            <p className="courseInfoContent"> {duration}</p>
          </div>
          <div>
            <p>Количество часов:</p>
            <p className="courseInfoContent">{hours}</p>
          </div>

          <div>
            <p>Документы: </p>
            <p className="courseInfoContent">{document_name}</p>
          </div>
        </div>
        <div className="scalesBox">
          <div className="moduleScaleBox">
            <span>Успеваемость</span>
            <ProgressScale scale={70} color="#00A060" />
          </div>
          <div className="moduleScaleBox">
            <span>Прохождение курса</span>
            <ProgressScale scale={scale} max={max} color="#0D6EFD" />
          </div>
        </div>
      </div>
      <div className="moduleImageBlock">
        <img
          alt=""
          src={"https://emir.gtsolifk.ru:4443/assets/" + layout}
          className="headCourseLayout"
        />
        <img
          alt=""
          src={"https://emir.gtsolifk.ru:4443/assets/" + background_color}
          className="headCourseBackground"
        />
      </div>
    </div>
  );
};

export default ModuleListHeadBlock;
